import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { CustomValidators } from 'src/app/utils/custom-validator';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { StateLovComponent } from '../../common/state-lov/state-lov.component';

@Component({
  selector: 'fire-flood-zone-maintenance',
  templateUrl: './fire-flood-zone-maintenance.component.html',
  styleUrls: ['./fire-flood-zone-maintenance.component.css']
})
export class FireFloodZoneMaintenanceComponent implements OnInit, LeaveConfirmation {

  private moduleId: string = 'BMM190';
  public moduleName: string = this._jDS.data.moduleList.find((a: any) => a.moduleId === this.moduleId)?.moduleDesc ?? "";

  constructor(
    public _formService: FormService,
    private fb: FormBuilder,
    private _matDialog: MatDialog,
    private _api: APICallService,
    private _jDS: JsonDataService,
    private _userDetailService: UserDetailsService,
    private _securityService: SecurityService,
    private _appMessageService: AppMessageService,
  ) {
    this.userIdLoggedIn = this._userDetailService.userId ?? "";
  }

  public canDeactivate(): boolean | Observable<boolean> {
    return !(this.fireFloodZoneTblConfig.tblData?.filter((row: any) => ['I', 'U'].includes(row.operation)).length > 0) && this.forms.fireFloodZoneForm.pristine;
  }

  public btns = {
    fireFloodZone: {
      updateDisabled: true,
      deleteDisabled: true,
      saveDisabled: true,
      addDisabled: false,
    },
  };

  public showForm: boolean = true;

  //* Data Stuffs */
  private rowData: any;
  private errorMessage: string = "";
  private userIdLoggedIn: string;
  //? set selectedRow to [] to unselect the table
  public selectedRow!: any[];

  private tempDataFromGet: any[] = [];

  public forms = {
    fireFloodZoneForm: this.fb.group({
      floodCd: [null, [Validators.required, Validators.maxLength(25), this.checkDuplicateFloodZone(), CustomValidators.requiredTrim]],
      floodShortDesc: [null, [Validators.required, Validators.maxLength(50), this.checkDuplicateFloodShortDesc(), CustomValidators.requiredTrim]],
      floodLongDesc: [null, [Validators.required, Validators.maxLength(1000), CustomValidators.requiredTrim]],
      active: ['A', [Validators.required]],
      bmCode: [null, [Validators.maxLength(8)]],
      remarks: [null, [Validators.maxLength(1000)]],
      lastUpdateUser: [{ value: '', disabled: 'true' }],
      lastUpdate: [{ value: '', disabled: 'true' }],
    }),
    resetfireFloodZoneForm: () => {
      this.forms.fireFloodZoneForm.reset();
      this.forms.fireFloodZoneForm.patchValue({
        active: 'A',
      });
      this.btns.fireFloodZone.updateDisabled = this.btns.fireFloodZone.deleteDisabled = true;
      this._formService.hideFormMsg("fire-flood-zone-error-message");
      this.rowData = null;
      this.forms.fireFloodZoneForm.get('floodCd')?.enable();
      this.forms.fireFloodZoneForm.markAsPristine();
    },
  };

  private fireFloodZoneFormManipulate = {
    dbToForm: (data: any) => {
      return {
        floodCd: data.FLOOD_ZONE_CD,
        floodShortDesc: data.FLOOD_SHORT_DESC,
        floodLongDesc: data.FLOOD_LONG_DESC,
        active: data.ACTIVE_TAG,
        bmCode: data.BM_CODE,
        remarks: data.REMARKS,
        lastUpdateUser: data.USER_ID,
        lastUpdate: data.LAST_UPDATE,
      };
    },
    formToDb: (data: any) => {
      return {
        FLOOD_ZONE_CD: data.floodCd?.trim(),
        FLOOD_SHORT_DESC: data.floodShortDesc?.trim(),
        FLOOD_LONG_DESC: data.floodLongDesc?.trim(),
        ACTIVE_TAG: data.active,
        BM_CODE: data.bmCode,
        REMARKS: data.remarks,
        USER_ID: null,
        LAST_UPDATE: null,
      };
    },
  }

  public fireFloodZoneTblConfig: any = {
    cols: [
      {
        key: "FLOOD_ZONE_CD",
        header: "Flood Zone Code",
        dataType: "string",
        width: '144px',
      },
      {
        key: "FLOOD_SHORT_DESC",
        header: "Short Description",
        dataType: "string",
        width: '196px',
      },
      {
        key: "FLOOD_LONG_DESC",
        header: "Long Description",
        dataType: "string",
      },
      {
        key: "BM_CODE",
        header: "BPIMS Code",
        dataType: "string",
        width: '128px',
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '48px',
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }

  ngOnInit(): void {
    this.getData.fireFloodZone();
  }

  private getData = {
    fireFloodZone: () => {
      try {
        this._jDS.contorlLoading(true);
        this._api.getFireFloodZone({
          moduleId: this.moduleId,
          userId: this._userDetailService.userId,
          type: "MODULE"
        }).subscribe({
          next: (response: any) => {
            this._securityService.checkRequestKeyResponse(response, () => {
              this._securityService.hasValidCsrfToken(response, () => {
                if (response.status === "SUCCESS") {
                  let content = JSON.parse(this._jDS.decrypt(response?.response));
                    this.fireFloodZoneTblConfig.tblData = [...content.data];
                    this._jDS.contorlLoading(false);
                    this.fireFloodZoneTblConfig.loading = false;
                }
                else {
                  this.fireFloodZoneTblConfig.tblData = [];
                  this._jDS.contorlLoading(false);
                  this.fireFloodZoneTblConfig.loading = false;
                }
              });
            });
          },
          error: (e: any) => {
            this._securityService.checkRequestKeyResponse(e, () => {

              this._jDS.contorlLoading(false);
              this.fireFloodZoneTblConfig.loading = false;
            });
          }
        });
      }
      catch (e) {
    console.error(e);

      }
    }
  };

  public selections = {
    activeTypes: [
      { cd: 'A', name: 'Yes' },
      { cd: 'I', name: 'No' },
    ],
  };

  public onRowClick(ev: any) {
    try {
      if (ev) {
        this.rowData = ev;
        this.forms.fireFloodZoneForm.get('floodCd')?.disable();
        this.populateFormFromTable();
        this.forms.fireFloodZoneForm.markAsPristine();
      }
      else {
        this.rowData = null;
        this.forms.resetfireFloodZoneForm();
      }
    }
    catch (e) {
      console.error(e);
      this.rowData = null;
      this.forms.resetfireFloodZoneForm();
    }
  }

  private populateFormFromTable() {
    try {
      let data = this.rowData;
      this.btns.fireFloodZone.updateDisabled = false;
      this.btns.fireFloodZone.deleteDisabled = !(this.rowData?.operation === 'I');
      this.forms.fireFloodZoneForm.patchValue(this.fireFloodZoneFormManipulate.dbToForm(data));
    }
    catch (e) {
    console.error(e);

    }
  }

  public onAdd(): void {
    try {
      this._formService.hideFormMsg("fire-flood-zone-error-message");
      if (this.forms.fireFloodZoneForm.valid) {
        let rowToBeAdded: { [key: string]: any } = this.fireFloodZoneFormManipulate.formToDb(this.forms.fireFloodZoneForm.getRawValue());
        rowToBeAdded.operation = 'I';
        this.fireFloodZoneTblConfig.tblData = [rowToBeAdded, ...this.fireFloodZoneTblConfig.tblData];
        this.forms.resetfireFloodZoneForm();
        this.btns.fireFloodZone.saveDisabled = false;
      }
      else {
        this.showErrorValidator.fireFloodZone();
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  public onUpdate(): void {
    try {
      this._formService.hideFormMsg("fire-flood-zone-error-message");
      if (this.forms.fireFloodZoneForm.valid) {
        const indexOfRow = this.fireFloodZoneTblConfig.tblData.indexOf(this.rowData);
        let rowToBeUpdated: { [key: string]: any } = this.fireFloodZoneFormManipulate.formToDb(this.forms.fireFloodZoneForm.getRawValue());
        rowToBeUpdated.operation = (this.rowData.operation === 'I') ? 'I' : 'U';
        rowToBeUpdated.FLOOD_ZONE_CD = this.rowData?.FLOOD_ZONE_CD;
        this.forms.resetfireFloodZoneForm();
        this.fireFloodZoneTblConfig.tblData[indexOfRow] = rowToBeUpdated;
        this.selectedRow = [];
        this.btns.fireFloodZone.saveDisabled = false;
        this.fireFloodZoneTblConfig.tblData = [...this.fireFloodZoneTblConfig.tblData];
      }
      else {
        this.showErrorValidator.fireFloodZone();
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  public onDelete(): void {
    try {
      this.fireFloodZoneTblConfig.tblData = this.fireFloodZoneTblConfig.tblData.filter((row: any) => {
        return row !== this.rowData;
      });
      this.forms.resetfireFloodZoneForm();
      let toBeSaved = this.fireFloodZoneTblConfig.tblData.filter((row: any) => ['I', 'U'].includes(row.operation));
      if (toBeSaved.length > 0) {
        this.btns.fireFloodZone.saveDisabled = false;
      }
      else{
        this.btns.fireFloodZone.saveDisabled = true;
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  public onSave(): void {
    try {
      this.showForm = false;
      this._formService.showFormLoader(null, "fire-flood-zone-maintenance-loading", "Saving.<br>Please wait ...", null, null, true);
      let toBeSaved = this.fireFloodZoneTblConfig.tblData.filter((row: any) => ['I', 'U'].includes(row.operation));
      if (toBeSaved.length > 0) {
        this._api.saveFireFloodZone(toBeSaved).subscribe({
          next: (response: any) => {
            this._securityService.checkRequestKeyResponse(response, () => {
              this._securityService.hasValidCsrfToken(response, () => {
                if (response.status === 'SUCCESS') {
                  this.onComplete.fireFloodZone();
                }
                else {
                  this.onComplete.fireFloodZoneError();
                }
              });
            });
          },
          error: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {

              this.onComplete.fireFloodZoneError();
            });
          }
        });
      }
      else {
        this.onComplete.fireFloodZone();
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  private onComplete = {
    fireFloodZone: () => {
      this._jDS.contorlLoading(false);
      this._formService.hideFormLoader("fire-flood-zone-maintenance-loading");
      this.openDialog('SUCCESS', this.moduleName.replace('Maintenance', ''), 'saved');
      this.btns.fireFloodZone.saveDisabled = true;
      this.showForm = true;
      this.forms.resetfireFloodZoneForm();
    },
    fireFloodZoneError: () => {
      this._jDS.contorlLoading(false);
      this.openDialog('FAILED', this.moduleName.replace('Maintenance', ''), 'saving');
      this._formService.hideFormLoader("fire-flood-zone-maintenance-loading");
      this.showForm = true;
      this.forms.resetfireFloodZoneForm();
    },
  }

  private openDialog(title: string, contentTitle: string, contentDetail: string) {
    try {
      this._matDialog.open(DialogMsgComponent, {
        disableClose: true,
        width: '512px',
        data: {
          title: title,
          content:
            title === 'SUCCESS'
              ? `${contentTitle} details successfully ${contentDetail}!`
              : `${contentTitle} details ${contentDetail} failed!`,
        },
      }).afterClosed().subscribe(() => {
        if (title === 'SUCCESS') {
          this.getData.fireFloodZone();
        }
      });
    }
    catch (e) {
    console.error(e);

    }
  }

  //* Validator Stuffs Down here */

  private checkDuplicateFloodZone(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim()?.toUpperCase();
      if (!value) return null;
      let hasDuplicate: boolean = this.fireFloodZoneTblConfig?.tblData.filter((d: any) => {
        if (!this.rowData)
          return d['FLOOD_ZONE_CD']?.trim().toUpperCase() === value;
        else
          return this.rowData['FLOOD_ZONE_CD']?.trim()?.toUpperCase() !== value && d['FLOOD_ZONE_CD']?.trim()?.toUpperCase() === value;
      }).length > 0 ? true : false;
      return hasDuplicate ? { hasDupe: true } : null;
    }
  }

  private checkDuplicateFloodShortDesc(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim()?.toUpperCase();
      if (!value) return null;
      let hasDuplicate: boolean = this.fireFloodZoneTblConfig?.tblData.filter((d: any) => {
        if (!this.rowData)
          return d['FLOOD_SHORT_DESC']?.trim().toUpperCase() === value;
        else
          return this.rowData['FLOOD_SHORT_DESC']?.trim()?.toUpperCase() !== value && d['FLOOD_SHORT_DESC']?.trim()?.toUpperCase() === value;
      }).length > 0 ? true : false;
      return hasDuplicate ? { hasDupe: true } : null;
    }
  }

  public showErrorValidator = {
    fireFloodZone: () => {
      try {
        Object.keys(this.forms.fireFloodZoneForm.controls).forEach(key => {
          const controlErrors = this.forms.fireFloodZoneForm.get(key)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              if (keyError == 'hasDupe' && controlErrors[keyError] === true && key === 'floodCd')
                this.errorMessage = "Flood Zone Code already exists. Please use a unique Flood Zone Code.";
              else if (keyError == 'hasDupe' && controlErrors[keyError] === true && key === 'floodShortDesc')
                this.errorMessage = "Flood Zone Short Description already exists. Please use a unique Flood Zone Short Description.";
              else if (keyError == 'required' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
            });
          }
        });
        this._formService.showFormMsg("fire-flood-zone-error-message", this.errorMessage, "E");
      }
      catch (e) {
    console.error(e);

      }
    },
  }

}
